import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { route } from '~/route';
import { Provider } from 'react-redux';
import ThemeProvider from '~/theme';
import { store } from '~/store';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { OfflineModeProvider } from '~/contexts/OfflineModeContext';

const router = createBrowserRouter(route);

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <OfflineModeProvider>
            <RouterProvider router={router} />
          </OfflineModeProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
